// Stock photos by vehicle type — used whenever a listing has no photo of its own,
// or when its photo fails to load, so grids never look empty.
const STOCK = {
  compact: "https://images.pexels.com/photos/27533382/pexels-photo-27533382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  hatchback: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&w=1200&q=80",
  sedan: "https://images.unsplash.com/photo-1623869675781-80aa31012a5a?auto=format&fit=crop&w=1200&q=80",
  suv: "https://images.unsplash.com/photo-1549632891-a0bea6d0355b?auto=format&fit=crop&w=1200&q=80",
  bakkie: "https://images.pexels.com/photos/19143577/pexels-photo-19143577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  convertible: "https://images.pexels.com/photos/8673506/pexels-photo-8673506.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  luxury: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80",
};

export const stockPhotoFor = (type) => STOCK[(type || "").toLowerCase()] || STOCK.sedan;

export const vehiclePhoto = (v) => (v?.photos && v.photos[0]) || stockPhotoFor(v?.vehicle_type);

/** onError handler: swap a broken image for the stock photo once. */
export const onPhotoError = (type) => (e) => {
  const fallback = stockPhotoFor(type);
  if (e.currentTarget.src !== fallback) e.currentTarget.src = fallback;
};
